module.exports = __webpack_public_path__ + "img/blog-main-08.5eb2b175.jpg";